import React, {Fragment} from "react";
import {ApiUtility} from "../common/ApiUtility";
import {useModelCreateEngine} from "../common/hooks/useModelCreateEngine";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {StripeCustomerForm} from "./StripeCustomerForm";

export let CreateStripeCustomer = function (props) {
    const modelCreateEngine = useModelCreateEngine(
        ApiUtility.createStripeCustomer,
        'Stripe customer',
        props.afterSuccessfulSave
    );

    return (
        <Fragment>
            <ConditionalRenderer if={modelCreateEngine.renderableData.loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <StripeCustomerForm
                cancel={props.cancel}
                save={modelCreateEngine.createModel}
                headerText="Add Stripe Customer"
                customer={props.customer}
                isNew={true}
            />
        </Fragment>
    );
};
